import React,{ Component } from 'react'
import ReactDOM from 'react-dom'
import ImgCodeInput from "../ImgCodeInput";
import './index.css'
import tipAlert from "../BsyAlertTip/Staticize";
import PubSub from "pubsub-js";

class BsyAlertImgCode extends Component{
    imgCodeValue = (ref) =>{
        this.imgCode = ref
    }
    getValue = () =>{
        const {value} = this.state;
        return {value}
    }
    render() {
        let {type, title, onCancel, onOk, target, value, mode} = this.props
        if(!onCancel){
            onCancel = () =>{
                document.getElementsByTagName("body")[0].removeChild(target.parentNode)
                ReactDOM.unmountComponentAtNode(target)
            }
        }
        if(!onOk){
            onOk = () =>{
                if(mode==="dingding"){
                    React.axios('/dingding/send_mobile_code',{
                        "country_code": value.countryCode,  //地区编号
                        "fly": this.imgCode.getValue().value,  //图形验证码
                        "mobile": value.value  //手机号
                    }).then(res =>{
                        if(res.data.errcode===0){
                            document.getElementsByTagName("body")[0].removeChild(target.parentNode)
                            ReactDOM.unmountComponentAtNode(target)
                            PubSub.publish('codeCont',{value:value});
                        }else{
                            this.imgCode.changeCode()
                            tipAlert({
                                type: "error",
                                msg : React.language(res.data.errmsg)
                            })
                        }
                    }).catch(res=>{
                        const res1 =  res.response ? res.response.data : res.data;
                        this.imgCode.changeCode()
                        // tipAlert({
                        //     type: "error",
                        //     msg : res1.msg
                        // })
                    })
                }else{
                    const data=value.accountType==="email"?{
                        "mode":mode==='active' ? 'active_code':'email_code' ,  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
                        "data":{
                            "email":value.value,
                            "code":this.imgCode.getValue().value //图形验证码
                        }
                    }:{
                        "mode":mode==='active' ? 'active_code':'mobile_code',  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
                        "data":{
                            "mobile":value.value,
                            "country_code":value.countryCode,  //地区编码
                            "code":this.imgCode.getValue().value //图形验证码
                        }
                    }

                    React.axios('/user/signin',data).then(res =>{
                        if(res.data.code===200){
                            tipAlert({
                                type: "success",
                                msg : res.data.msg
                            })
                            document.getElementsByTagName("body")[0].removeChild(target.parentNode)
                            ReactDOM.unmountComponentAtNode(target)
                            PubSub.publish('codeCont',{value:value});
                        }else if(res.data.code===400){
                            tipAlert({
                                type: "error",
                                msg : res.data.msg
                            })
                        }
                    }).catch(res=>{
                        const res1 =  res.response ? res.response.data : res.data;
                        this.imgCode.changeCode()
                        if(res1.toString().indexOf('"Message":"OK"') === -1)
                        {
                            if(res1.toString().indexOf('code'))
                            {
                                // tipAlert({
                                //     type: "error",
                                //     msg : res1.msg
                                // })
                            }
                            else
                            {
                                // tipAlert({
                                //     type: "error",
                                //     msg : React.language("System.error")
                                // })
                            }
                        }else{
                            tipAlert({
                                type: "success",
                                msg : res1.msg
                            })
                            document.getElementsByTagName("body")[0].removeChild(target.parentNode)
                            ReactDOM.unmountComponentAtNode(target)
                            PubSub.publish('codeCont',{value:value});
                        }
                    })
                }
            }
        }
        return (
            <div className={"content " + type}>
                <div className="title">
                    {title}
                </div>
                <ImgCodeInput getValue={this.imgCodeValue} />
                <div className="bottom-btn">
                    <button onClick={onCancel} className="cancel-btn">
                        {React.language('cancel')}
                    </button>
                    <button onClick={onOk} className="ok-btn">
                        {React.language('ok')}
                    </button>
                </div>
            </div>
        )
    }
}

export default BsyAlertImgCode